import { useUser } from "@Light/components/auth/context";
import { ButtonFooter } from "@Light/components/page/ButtonFooter";
import { useHeaderTitle } from "@Light/components/page/header/context";
import { MutationButton } from "@Light/components/page/MutationButton";
import { useScaffold } from "@Light/scaffold";
import { useAPI } from "@Light/services/api";
import { UpdateUser } from "@Light/services/apiTypes";
import { useLight } from "@Light/services/light";
import { useDispatch, useNavigate } from "@Light/utils/context";
import { useMutation } from "@Light/utils/mutation";
import React, { useEffect } from "react";
import { useForm, useWatch } from "react-hook-form";

const BACK_ROUTE = "/account/details/";

export type UpdateEmailProps = {};

export const UpdateEmail: React.FC<UpdateEmailProps> = ({}) => {
  const scaffold = useScaffold();
  const { useUpdateUserMutation } = useAPI();
  const user = useUser();
  const updateUser = useMutation<UpdateUser>(useUpdateUserMutation);
  const { register, handleSubmit, control } = useForm();
  const email = useWatch({ control, name: "email" });
  const disabled = user.email === email;
  const light = useLight();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useHeaderTitle("Update your email");

  useEffect(() => {
    if (!updateUser.isSuccess) {
      return;
    }
    // Tell redux to invalidate our account data as the back end server should
    // have updated its value.
    dispatch(light.util.invalidateTags(["Account"]));
    navigate(BACK_ROUTE);
  }, [updateUser.isSuccess, light, dispatch, navigate]);

  const mutate = handleSubmit(({ email }: any) => {
    updateUser.mutate({ email });
  });

  const PageBody = scaffold.page.pageBody;
  const Field = scaffold.system.field;
  const Label = scaffold.system.label;
  const Input = scaffold.system.input;
  return (
    <form onSubmit={mutate}>
      <PageBody
        backLink={BACK_ROUTE}
        footerAfterContent={true}
        footer={
          <ButtonFooter>
            <MutationButton
              size="lg"
              mutate={mutate}
              mutation={updateUser}
              mutateButtonText="Confirm"
              errorMessage="Error updating your email. Please try again later."
              disabled={disabled}
            />
          </ButtonFooter>
        }
      >
        <div className="pt-8 flex flex-col gap-4">
          <Field>
            <Label>Email</Label>
            <Input
              {...register("email", {
                required: true,
                value: user.email,
              })}
            />
          </Field>
        </div>
      </PageBody>
    </form>
  );
};
